import { createRoot, Root } from 'react-dom/client';
import React from 'react';
import { exportIds } from '../../config/config';
import { ExportApp } from './ExportApp';

let exportRootInstance: Root | null = null;

export function mountExportRoot(exportUrl: string): void {
  const container = document.getElementById(exportIds.pdfExportRoot);
  if (!container) return;

  exportRootInstance = createRoot(container);
  exportRootInstance.render(
    React.createElement(ExportApp, { exportUrl })
  );
}

export function unmountExportRoot(): void {
  const container = document.getElementById(exportIds.pdfExportRoot);
  if (!container || !exportRootInstance) return;

  exportRootInstance.unmount();
  exportRootInstance = null;
}
